import {extend} from 'flarum/extend';
import app from 'flarum/app';
import IndexPage from 'flarum/components/IndexPage';
import UserPage from 'flarum/components/UserPage';
import LinkButton from 'flarum/components/LinkButton';
import SettingsLinkButton from './components/SettingsLinkButton';

export default function () {
    extend(IndexPage.prototype, 'navItems', function (items) {
        if (app.forum.attribute('formulaireCanManage')) {
            items.add('formulaire', SettingsLinkButton.component());
        }
    });

    extend(UserPage.prototype, 'navItems', function (items) {
        const forms = this.user.formulaireForms();

        if (forms) {
            forms.forEach(form => {
                items.add('formulaire-' + form.id(), LinkButton.component({
                    icon: 'fas fa-poll-h',
                    href: app.route.formulaireProfile(this.user, form),
                }, form.title()));
            });
        }
    });
}
